import _ from 'lodash';
import dfp_config from 'ads/dfp/dfp_config';
import abtest from 'common/abtest';

const adConfig = _.result(abtest, 'adConfig.config', dfp_config);
export default adConfig
